<!-- 
    描述：会议室申请记录详情页
-->
<template>
    <div class="h100">
        <div class="filed-info-layout operation-layout">
            <div class="operation-main">
                <div class="operation-header">
                    <div class="common-top">
                        <!-- <div class="text-right pdt10">
                            <el-button
                                type="primary"
                                class="btn-blue"
                                @click="goBack"
                                size="small"
                                >返回</el-button
                            >
                        </div> -->
                        <div class="top-box">
                            <div class="h100 left-area">
                                <div class="left-box">
                                    <div class="booking h100">
                                        <p class="text-center">
                                            <span
                                                class="number-style activeColor"
                                                >{{
                                                    parseInt(
                                                        childObj.appointmentCount
                                                    ) +
                                                        parseInt(
                                                            childObj.usedCount
                                                        )
                                                }}</span
                                            >次
                                        </p>
                                        <p class="text-style text-center">
                                            全部预约记录
                                        </p>
                                    </div>
                                    <div class="splitLine"></div>
                                    <div class="booking h100">
                                        <p class="text-center">
                                            <span
                                                class="number-style"
                                                :class="{
                                                    activeColor:
                                                        bookState == '1'
                                                }"
                                                >{{
                                                    childObj.appointmentCount
                                                }}</span
                                            >次
                                        </p>
                                        <p class="text-style text-center">
                                            当前预约中
                                        </p>
                                    </div>
                                    <div class="splitLine"></div>
                                    <div class="used h100">
                                        <p class="text-center" :class="">
                                            <span
                                                class="number-style"
                                                :class="{
                                                    activeColor:
                                                        bookState == '2'
                                                }"
                                                >{{ childObj.usedCount }}</span
                                            >次
                                        </p>
                                        <p class="text-style text-center">
                                            已使用次数
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="mt10 right-area">
                                <el-row>
                                    <el-col class="text-overflow" :span="6"
                                        >会议室名称：</el-col
                                    >
                                    <el-col class="text-overflow" :span="18">{{
                                        childObj.sname
                                    }}</el-col>
                                    <el-col class="text-overflow" :span="6"
                                        >归属场地：</el-col
                                    >
                                    <el-col class="text-overflow" :span="18">{{
                                        childObj.placeName
                                    }}</el-col>
                                    <el-col class="text-overflow" :span="6"
                                        >会议室类型：</el-col
                                    >
                                    <el-col class="text-overflow" :span="18">{{
                                        childObj.typeName
                                    }}</el-col>
                                </el-row>
                            </div>
                        </div>
                        <el-row>
                            <Tab
                                @change="tabChange"
                                :dataArray.sync="dataArray"
                                :value="bookState"
                                ref="tab"
                                class="tab-style"
                            ></Tab>
                        </el-row>
                    </div>
                    <el-row>
                        <el-col :span="24">
                            <div class="tip-num">
                                <p>
                                    合计预约记录
                                    <span>{{
                                        parseInt(childObj.appointmentCount) +
                                            parseInt(childObj.usedCount)
                                    }}</span>
                                    个
                                </p>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div class="operation-container w-table-layout w-table-page">
                    <div class="w-table-content">
                        <el-table
                            ref="xTable"
                            height="100%"
                            highlight-current-row
                            :data="filterData"
                            border
                        >
                            <el-table-column
                                prop="sysNo"
                                label="预约流水号"
                                align="center"
                                width="200"
                            ></el-table-column>
                            <el-table-column
                                prop="createDate"
                                label="预约时间"
                                align="center"
                                width="200"
                            ></el-table-column>
                            <el-table-column
                                prop="projectName"
                                label="项目名称"
                                align="center"
                                width="250"
                            ></el-table-column>
                            <el-table-column
                                prop="companyName"
                                label="预约单位"
                                align="center"
                                width="250"
                            ></el-table-column>
                            <el-table-column
                                prop="useStartTime"
                                label="开始时间"
                                align="center"
                                width="200"
                            ></el-table-column>
                            <el-table-column
                                prop="useEndTime"
                                label="结束时间"
                                align="center"
                                width="200"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                prop="remark"
                                label="说明"
                                align="center"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                prop="applyState"
                                label="状态"
                                align="center"
                                width="100"
                                show-overflow-tooltip
                            >
                                <template slot-scope="scope">
									<span :class="dealClass(scope.row.applyState)">
										{{ dealTitle(scope.row.applyState) }}
									</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="w-table-footer">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="pageList"
                            :page-size="pageSize"
                            :total="total"
                            layout="total, sizes, prev, pager, next, jumper"
                        >
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Tab from '@/components/common/tab'
import { getOperateMeetDetailList } from 'api/modules/fieldManagement'
export default {
    components: {
        Tab
    },
    props: {
        childObj: {
            type: Object,
            default: () => ({})
        }
    },
    mounted() {
        this.childObj.id
            ? this.getMeetingApplyList(this.childObj.id)
            : this.goBack()
    },
    data() {
        return {
            dataArray: [
                { label: '全部', name: '0' },
                { label: '预约中', name: '1' },
                { label: '已使用', name: '2' }
            ],
            filterData: [],
            bookState: '0',
            currentPage: 1, // 当前页码
            pageList: [10, 20, 50, 100], // 显示条数数组
            pageSize: 20, // 当前显示条数
            total: 0 // 当前总条数
        }
    },
    methods: {
        // 返回
        goBack() {
            this.$router.push({ path: '/room-records' })
        },

        // tab切换
        tabChange(val) {
			this.currentPage = 1
            this.bookState = val
            this.getMeetingApplyList(this.childObj.id)
        },

        // 获取会议室申请记录明细
        getMeetingApplyList(id) {
            let params = {}
            params.size = this.pageSize
            params.current = this.currentPage
            params.meetingId = id
            params.applyState = this.bookState

            getOperateMeetDetailList(params).then(d => {
                if (d.code == 0) {
                    this.filterData = d.data.records
                    this.currentPage = parseInt(d.data.current)
                    this.total = parseInt(d.data.total)
                    this.pageSize = parseInt(d.data.size)
                }
            })
        },

        // 切换显示条数
        handleSizeChange(val) {
            this.pageSize = val
            this.getMeetingApplyList(this.childObj.id)
        },

        //切换当前页码
        handleCurrentChange(val) {
            this.currentPage = val
            this.getMeetingApplyList(this.childObj.id)
        },

		// 处理状态
		dealTitle(data) {
			let msg = ''
			switch (data) {
				case 0:
					msg = '空闲'
					break
				case 1:
					msg = '锁定'
					break
				case 2:
					msg = '占用中'
					break
			}
			return msg
		},

		// 处理状态
		dealClass(data) {
			let msg = ''
			switch (data) {
				case 0:
					msg = 'deep-state'
					break
				case 1:
					msg = 'red-state'
					break
				case 2:
					msg = 'cyan-state'
					break
			}
			return msg
		},
    }
}
</script>
<style lang='less' scoped>
.filed-info-layout {
    padding: 0 !important;
    .operation-header {
        height: 250px;
        display: block;
        .top-box {
            height: 161px;
            padding: 0 10px 24px 0;
            display: flex;
        }
        .left-area {
            display: flex;
            align-items: center;
            width: 300px;
        }
        .left-box {
            width: 300px;
            height: 93px;
            background: rgb(245, 247, 253);
            border: 1px solid #abc0fa;
            border-radius: 5px;
            display: flex;
            align-items: center;
        }
        .booking,
        .used {
            width: 100px;
            height: 100%;
            padding: 10px 0;
        }
        .splitLine {
            width: 1px;
            height: 60px;
            background-color: #abc0fa;
        }
        .text-style {
            font-size: 12px;
        }
        .number-style {
            font-size: 30px;
        }
        .activeColor {
            color: #2672cc;
        }
        .right-area {
            line-height: 33px;
            margin-left: 30px;
            margin-top: 20px;
            .el-col-6 {
                font-size: 14px;
                color: #666;
                text-align: right;
            }
            .el-col-18 {
                font-size: 14px;
                color: #202020;
            }
        }
    }
    .tab-style {
        /deep/ .el-tabs__item {
            width: 100px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            background: #f0f0f0;
            border-radius: 3px 3px 0px 0px;
            color: #666;
            margin-right: 20px;
            padding: 0;
            .el-tabs__header {
                border-bottom: 1px solid #2671cc;
            }
        }
        /deep/ .el-tabs__item.is-active {
            color: #fff;
            background-color: #2671cc !important;
        }
        /deep/ .el-tabs__nav-wrap::after {
            background-color: #2671cc;
            height: 1px;
            z-index: 999;
        }
        /deep/ .el-tabs__active-bar {
            background-color: transparent;
        }
    }
    .tip-num {
        padding: 8px 0;
        p {
            padding-left: 10px;
            border-left: 4px solid #2672cc;
        }
        span {
            color: #2672cc;
            font-size: 18px;
        }
    }
    .operation-container {
        height: calc(~'100% - 250px');
    }
}
</style>
